import React from "react";

export const ChoiceChip = ({ label, isSelected, onClick, width, height }) => {
  const classNames = ["choice-chip"];
  if (isSelected) classNames.push("choice-chip--selected");

  return (
    <div
      className={classNames.join(" ")}
      onClick={onClick && onClick}
      style={{ height: height ?? "auto", width: width ?? "auto" }}
    >
      <div className="choice-chip__label">{label}</div>
    </div>
  );
};
